import script from "./AnalysesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnalysesList.vue?vue&type=script&setup=true&lang=ts"

import "./AnalysesList.vue?vue&type=style&index=0&id=5ee25882&lang=scss"

const __exports__ = script;

export default __exports__